// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74b6b1fa","993":"99c6577d"}[chunkId] + ".chunk.js";
};